module.exports = __webpack_public_path__ + "static/media/ic-business-info-black.f116336c.svg";